import axios from 'axios'
import { responseStatusStore } from '../stores/ResponseStatusStore'

// For debugging
window.axios = axios

const axiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 500) {
        responseStatusStore.setError500()
      }

      return Promise.reject(error)
    }
  )
}

export default axiosInterceptors
